import { useMemo } from 'react';
import { Link } from 'react-router';
import { useLiveQuery } from 'dexie-react-hooks';
import { Banner } from '@/components/Banner';
import { hayDatosCapturados } from '@/db/schema';
import { detectarPlataforma } from './platform';

/**
 * Aviso de almacenamiento separado en iOS (Req. 2.6).
 *
 * En iOS la app instalada en la pantalla de inicio NO comparte IndexedDB con
 * Safari. Si se registra algo en Safari, no aparecerá en la app instalada, y
 * esa confusión se siente como una pérdida de datos.
 *
 *   - Con datos registrados en Safari -> advertencia de almacenamiento separado.
 *   - Sin datos                       -> invitación a instalar.
 *
 * Origen: Control de Negocio de Comida, con los textos y rutas adaptados.
 */
export function StandaloneNotice() {
  const plataforma = useMemo(() => detectarPlataforma(), []);
  const hayDatos = useLiveQuery(() => hayDatosCapturados(), [], false);

  // En la app instalada no hay nada que advertir.
  if (plataforma.enStandalone) return null;

  if (hayDatos === true) {
    return (
      <Banner tono="alerta" titulo="Estás usando el navegador, no la app instalada">
        <p>
          Lo que registres aquí <strong>no aparecerá</strong> en la app instalada en tu pantalla
          de inicio: iOS guarda cada una por separado.
        </p>
        <p className="mt-2">
          Para no dividir tu información, registra siempre desde la app instalada. Si ya
          registraste algo aquí, expórtalo en{' '}
          <Link to="/mas/respaldos" className="font-medium text-marca underline">
            Respaldos
          </Link>{' '}
          y restáuralo desde la app instalada.
        </p>
      </Banner>
    );
  }

  return (
    <Banner tono="aviso" titulo="Instala DuoFit antes de registrar datos">
      <p>
        En iOS la app instalada y Safari guardan datos por separado. Instálala primero para que
        toda tu información quede en un solo lugar.
      </p>
      <p className="mt-2">
        <Link to="/mas/instalar" className="font-medium text-marca underline">
          Ver cómo instalarla
        </Link>
      </p>
    </Banner>
  );
}
